import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Slide,
  Toolbar,
  useScrollTrigger,
} from "@mui/material";
import SpLogo from "../../assets/images/sp-logo.png";
import AshdodLogo from "../../assets/images/city_logo.png";
import { SPColor } from "../../constants/color";

export default function Topbar(props: any) {
  const [trigger, setTrigger] = useState<boolean>(false);

  const scrollTrigger = useScrollTrigger({
    threshold: 84,
  });

  useEffect(() => {
    setTrigger(scrollTrigger);
  }, [scrollTrigger]);

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      {/* {trigger && (
        <AppBar position="fixed" sx={{ backgroundColor: SPColor.BLUE }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              <img src={SpLogo} alt="speakingpal logo" height="50" />
              <Box sx={{ flexGrow: 1 }}></Box>
              <Box sx={{ flexGrow: 0 }}>
                <img src={AshdodLogo} height="80" />
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      )} */}
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img src={SpLogo} alt="speakingpal logo" height="50" />
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box sx={{ flexGrow: 0 }}>
            <img src={AshdodLogo} height="65" />
          </Box>
        </Toolbar>
      </Container>
    </div>
  );
}
